import React from 'react';
import { DataTable } from '../components/DataTable';
import { LoadingBlock } from '../components/LoadingBlock';
import { SectionCard } from '../components/SectionCard';

function ChampionshipSelect({ championships, selectedChampionshipId, onSelectChampionship }) {
  if (!championships.length) {
    return null;
  }

  return (
    <label>
      Campeonato
      <select value={selectedChampionshipId ? String(selectedChampionshipId) : ''} onChange={(event) => onSelectChampionship(event.target.value ? Number(event.target.value) : null)}>
        {championships.map((item) => <option key={item.id} value={item.id}>{item.name}</option>)}
      </select>
    </label>
  );
}

export function StatisticsPage({ loading, error, playerData, teamData, championships = [], selectedChampionshipId, onSelectChampionship }) {
  if (loading) return <LoadingBlock label="Carregando estatísticas consolidadas..." />;
  if (error) return <div className="page-error">{error}</div>;

  const playerItems = playerData?.items || [];
  const teamItems = teamData?.items || [];
  const topScorer = playerItems.reduce((best, current) => (!best || Number(current.goals || 0) > Number(best.goals || 0) ? current : best), null);
  const topAssist = playerItems.reduce((best, current) => (!best || Number(current.assists || 0) > Number(best.assists || 0) ? current : best), null);
  const bestCleanSheet = teamItems.reduce((best, current) => (!best || Number(current.clean_sheets || 0) > Number(best.clean_sheets || 0) ? current : best), null);

  return (
    <div className="page-grid two-columns">
      <SectionCard
        title="Estatísticas de jogadores"
        subtitle="Leitura consolidada por campeonato, alimentada por eventos e encerramento de partidas."
        actions={<ChampionshipSelect championships={championships} selectedChampionshipId={selectedChampionshipId} onSelectChampionship={onSelectChampionship} />}
      >
        <div className="callout-box compact-box admin-callout">
          <span className="eyebrow">Leitura do administrador</span>
          <strong>Motor estatístico automático</strong>
          <p>Os números são consolidados pelo encerramento da partida e pelos eventos lançados na central. O admin audita a consistência técnica e corrige a origem do jogo, não a tabela estatística manualmente.</p>
        </div>

        <div className="callout-grid admin-summary-grid">
          <div className="callout-box compact-box"><span className="eyebrow">Artilheiro</span><strong>{topScorer?.full_name || '-'}</strong><p>{topScorer ? `${topScorer.goals} gols` : 'Sem leitura disponível.'}</p></div>
          <div className="callout-box compact-box"><span className="eyebrow">Maior assistente</span><strong>{topAssist?.full_name || '-'}</strong><p>{topAssist ? `${topAssist.assists} assistências` : 'Sem leitura disponível.'}</p></div>
          <div className="callout-box compact-box"><span className="eyebrow">Melhor defesa</span><strong>{bestCleanSheet?.team_name || '-'}</strong><p>{bestCleanSheet ? `${bestCleanSheet.clean_sheets} jogos sem sofrer gols` : 'Sem leitura disponível.'}</p></div>
          <div className="callout-box compact-box"><span className="eyebrow">Jogadores lidos</span><strong>{playerItems.length}</strong><p>Atletas presentes na consolidação atual.</p></div>
        </div>

        <DataTable
          rows={playerItems}
          columns={[
            { key: 'full_name', label: 'Jogador' },
            { key: 'team_name', label: 'Time' },
            { key: 'games', label: 'J' },
            { key: 'goals', label: 'Gols' },
            { key: 'assists', label: 'Assist.' },
            { key: 'yellow_cards', label: 'Am.' },
            { key: 'red_cards', label: 'Vm.' },
          ]}
          emptyText="Sem estatísticas de jogadores para o campeonato selecionado."
        />
      </SectionCard>

      <SectionCard title="Estatísticas de times" subtitle="Base consolidada para leitura técnica do campeonato.">
        <div className="callout-box compact-box admin-callout subtle-callout">
          <span className="eyebrow">Uso operacional</span>
          <strong>Leitura de performance coletiva</strong>
          <p>Use esta tela para enxergar ataque, defesa e jogos sem sofrer gols. Quando algo sair errado, a correção deve acontecer no jogo e nos eventos da partida.</p>
        </div>

        <DataTable
          rows={teamItems}
          columns={[
            { key: 'team_name', label: 'Time' },
            { key: 'games', label: 'J' },
            { key: 'goals_scored', label: 'GP' },
            { key: 'goals_conceded', label: 'GC' },
            { key: 'clean_sheets', label: 'SG' },
          ]}
          emptyText="Sem estatísticas de times para o campeonato selecionado."
        />
      </SectionCard>
    </div>
  );
}
